<div class="background" cdkDrag>
  <div class="" cdkDragHandle>{{ 'emoji.select' | loc }}</div>
  <div *ngIf="lastSelected.length">{{ 'emoji.last' | loc }}</div>
  <div class="emoji-grid">
    <span *ngFor="let option of lastSelected" (mousedown)="select($event, option)">{{ option.emoji }}</span>
  </div>
  <div *ngFor="let key of categoryKeys">
    <ng-container *ngIf="emojiMap.get(key) as options">
      <div>{{ key | locCap }}</div>
      <div class="emoji-grid">
        <!-- * The mousedown event will be handled before the focus of another element is lost. -->
        <span *ngFor="let option of options" (mousedown)="select($event, option)">{{ option.emoji }}</span>
      </div>
    </ng-container>
  </div>
</div>
